export const SHIFTBOOK_DOMAIN_EVENTS = {
  entriesListStarted: 'shiftbook.entries.list.started',
  entriesListSuccess: 'shiftbook.entries.list.success',
  entriesListFailure: 'shiftbook.entries.list.failure',
  entriesDetailStarted: 'shiftbook.entries.detail.started',
  entriesDetailSuccess: 'shiftbook.entries.detail.success',
  entriesDetailNotFound: 'shiftbook.entries.detail.not-found',
  entriesCreatedStarted: 'shiftbook.entries.create.started',
  entriesCreatedSuccess: 'shiftbook.entries.create.success',
  entriesCreatedFailure: 'shiftbook.entries.create.failure',
  entriesUpdatedStarted: 'shiftbook.entries.update.started',
  entriesUpdatedSuccess: 'shiftbook.entries.update.success',
  entriesUpdatedFailure: 'shiftbook.entries.update.failure',
  searchDegradedToSql: 'shiftbook.search.degraded-to-sql',
  searchTelemetryFailed: 'shiftbook.search.telemetry-failed',
  lookupSuccess: 'shiftbook.lookups.success',
  lookupFailure: 'shiftbook.lookups.failure',
  attachmentHandlingStarted: 'shiftbook.attachments.handling.started',
  attachmentHandlingSuccess: 'shiftbook.attachments.handling.success',
  attachmentHandlingFailure: 'shiftbook.attachments.handling.failure',
} as const;

export const FRONTEND_API_EVENTS = {
  requestStarted: 'frontend.api.request.started',
  requestSucceeded: 'frontend.api.request.succeeded',
  requestFailed: 'frontend.api.request.failed',
} as const;

export const FRONTEND_UI_EVENTS = {
  errorBoundary: 'frontend.ui.error-boundary',
  serviceWorkerError: 'frontend.pwa.service-worker-failed',
  loggerMissingDsn: 'frontend.sentry.missing-dsn',
} as const;

export const LOG_EVENTS = {
  ...SHIFTBOOK_DOMAIN_EVENTS,
  ...FRONTEND_API_EVENTS,
  ...FRONTEND_UI_EVENTS,
} as const;

export type ShiftbookDomainEvent =
  (typeof SHIFTBOOK_DOMAIN_EVENTS)[keyof typeof SHIFTBOOK_DOMAIN_EVENTS];
export type FrontendApiEvent = (typeof FRONTEND_API_EVENTS)[keyof typeof FRONTEND_API_EVENTS];
export type FrontendUiEvent = (typeof FRONTEND_UI_EVENTS)[keyof typeof FRONTEND_UI_EVENTS];
export type LogEvent = (typeof LOG_EVENTS)[keyof typeof LOG_EVENTS];

export type LogOutcome = 'success' | 'failure' | 'degraded' | 'pending';

export interface CommonLogPayload {
  event: LogEvent;
  requestId?: string;
  traceId?: string;
  role?: string;
  site?: string;
  shift?: string;
  route?: string;
  outcome: LogOutcome;
  statusCode?: number;
  durationMs?: number;
  latencyBucket?: string;
  resultCount?: number;
}

export interface ApiRequestPayload extends CommonLogPayload {
  event:
    | FrontendApiEvent
    | 'frontend.api.request.started'
    | 'frontend.api.request.succeeded'
    | 'frontend.api.request.failed';
  status?: number;
  method?: string;
  path?: string;
}

export interface FrontendBoundaryPayload extends CommonLogPayload {
  event: FrontendUiEvent;
}
